import FORM_BUILDER from 'ui-blocks/form-builder/constants';
import { options } from '../../../../ui-blocks/form-elements/select/StateSelect';
import {
   sponsoredAdsCampaignManagerCreateCampaign,
   sponsoredAdsCampaignManagerEditCampaign,
   sponsoredAdsCampaignManagerLoadCampaign,
} from '../../services/servicesSponsoredAds';
import { deviceTypeSelectOptions } from './FormDisplay';

const stateLookupOptions = {};

options.forEach((state) => {
   stateLookupOptions[state.id] = state.label;
});

const getStateInitialValues = (states) => {
   return states?.map((state) => {
      if (!state?.latitude) {
         const id = state?.id;
         const label = stateLookupOptions[id?.toLowerCase()];
         return {
            id, value: id, label, name: label,
         };
      }
      return state;
   });
};

export const mapRespToInitialValues = (resData) => {
   const initialValues = { ...resData };

   let deviceInitialValue = {
      label: 'All Devices',
      value: 'ALL',
   };
   deviceTypeSelectOptions.forEach((deviceOption) => {
      if (deviceOption.value === initialValues.device) {
         deviceInitialValue = { ...deviceOption };
      }
   });

   initialValues.dailyBudget = initialValues.dailyBudget > 0 ? initialValues.dailyBudget : 0;
   initialValues.monthlyBudget = initialValues.monthlyBudget > 0 ? initialValues.monthlyBudget : 0;
   initialValues.paymentType = initialValues.paymentType === 'cpa';
   initialValues.paymentTypeValue = initialValues.paymentType ? initialValues.cpa : initialValues.cpc;
   initialValues.keywords = initialValues.keywords?.map((keyword) => ({
      id: `${ keyword.id }`, value: keyword.name, label: keyword.name,
   }));
   initialValues.location = getStateInitialValues(initialValues.whitelistGeoStates);
   initialValues.exclude = getStateInitialValues(initialValues.blacklistGeoStates);
   initialValues.approval = initialValues.status;
   initialValues.radius = { label: `${ initialValues.radius }`, value: initialValues.radius };
   initialValues.device = deviceInitialValue;
   initialValues.active = initialValues.active === true;

   return initialValues;
};

const formBuilderConfig = {
   defaultInitialValues: {
      device: {
         label: 'All Devices',
         value: 'ALL',
      },
      radius: {
         label: '25',
         value: 25,
      },
      exclude: [],
      location: [],
   },
   settings: {
      type: FORM_BUILDER.TYPE.EDIT_ADD,
      internal: {
         routing: {
            basePath: '/sponsored-ads/campaign-manager',
         },
      },
      external: {
         api: {
            get: sponsoredAdsCampaignManagerLoadCampaign,
            save: {
               create: sponsoredAdsCampaignManagerCreateCampaign,
               edit: sponsoredAdsCampaignManagerEditCampaign,
            },
            // getInitialValues:       -- value is a promise
            // save :                  -- has two value variations to take into consideration for the (1) Case: theres one API for
            //                            create & edit and for the (2) Case: where theres two separate APIs for 'create' and 'edit'
            //          E.g., Save Variation Value #1 -- value is a promise
            //          E.g., Save Variation Value #2 -- value is an object with the shape
            //                {
            //                   edit,       // -- value is a promise
            //                   create,     // -- value is a promise
            //                }
            responseMiddleware: {
               get: (res) => mapRespToInitialValues(res?.data),
            },
         },
      },
   },
};

export default formBuilderConfig;
